import BaseControlTypeConst from "./BaseControlTypeConst"

export default class RadioButtonTypeConst extends BaseControlTypeConst {

    static VALUE='value'
    static INPUTID='inputId'
    static READONLY = 'readonly'
}
